import { RouteProp, useRoute } from '@react-navigation/native';
import ParkMap from 'components/map/ParkMap';
import PermitSearchSheet from 'components/park/longTermParking/PermitSearchSheet';
import { useGetParkingZonesWithBuyablePermits } from 'hooks/useGetParkingZonesWithBuyablePermits';
import React, { useEffect } from 'react';
import { useActiveElementStore } from 'stores/activeElementStore';
import { useAuthStore } from 'stores/authStore';
import { useParkingStore } from 'stores/parkingStore';
import { useSearchStore } from 'stores/searchStore';
import { LongTermStackParamList } from 'types/navigation';

const MapScreen: React.FC<{
  showBeforeMapLoaded?: boolean;
  isTesting?: boolean;
}> = ({ showBeforeMapLoaded = false, isTesting = false }) => {
  const { setSearchInputActive } = useSearchStore((state) => state);
  const { setParkingConditions } = useParkingStore((state) => state);
  const { params } = useRoute<RouteProp<LongTermStackParamList, 'mapScreen'>>();
  const currentAppCountry = useAuthStore(
    (state) => state.currentCustomerCountry
  );
  const { parkingZonesData } = useGetParkingZonesWithBuyablePermits(
    currentAppCountry,
    true
  );

  useEffect(() => {
    if (params?.parkingZoneUid) {
      useActiveElementStore.getState().setActiveElement(params?.parkingZoneUid);
      //For now we keep also the activeElement. Refactoring it would affect alot of files and for now we just try to refactor the
      // start parking flow, so we set both values here.
      setParkingConditions({ selectedParkingZoneId: params?.parkingZoneUid });
    }
  }, [params?.parkingZoneUid, setParkingConditions]);

  useEffect(() => {
    return () => {
      setSearchInputActive(false);
    };
  }, [setSearchInputActive]);

  return (
    <>
      <ParkMap
        showBeforeMapLoaded={showBeforeMapLoaded}
        showLogo={false}
        parkingZonesData={parkingZonesData}
        showBackButton={true}
        withLTP={true}
      />
      <PermitSearchSheet isTesting={isTesting} />
    </>
  );
};

export default MapScreen;
